import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { required } from "../../../shared/src/codecs/types/required";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { form } from "../../../shared/src/codecs/types/form";
import { string } from "../../../shared/src/codecs/types/string";
import { EmptyObject } from "../EmptyObject";
import { ListingLostReason1 } from "../ListingLostReason";

export const MarkListingAgencyLostFormInput = required({
    listing_id: uuid(),
    lost_reason: ListingLostReason1,
    lost_reason_notes: string(),
});

export const MarkListingAgencyLostForm = form(
    MarkListingAgencyLostFormInput,
    EmptyObject,
);

export type TMarkListingAgencyLostFormCodec = typeof MarkListingAgencyLostForm;
export type TMarkListingAgencyLostForm = TTypeOfCodec<TMarkListingAgencyLostFormCodec>;
export type TMarkListingAgencyLostFormNewDefault = TTypeOfNewDefault<TMarkListingAgencyLostFormCodec>;
